import { AgGridReactProps } from '@ag-grid-community/react';
import { Button, makeStyles } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MainColumns } from '../../../../../../components/TableGrid';
import { FontSizes } from '../../../../../../core/config/mainTheme';
import DetailsDataTable from '../DetailsDataTable/DetailsDataTable';

const defaultColDef = {
  unSortIcon: true,
  sortable: true,
  menuTabs: [],
};

interface GridData<T = any> {
  currentDetail: T[];
  historicDetail: T[];
}

interface DetailsDataTableWithHistoryProps extends AgGridReactProps {
  data?: Partial<GridData>;
  title: string;
  translationsScope: string;
  columns: MainColumns[];
  actions?: React.ReactNode;
  defaultHistoryToggleValue?: boolean;
}

const DetailsDataTableWithHistory: React.FC<DetailsDataTableWithHistoryProps> = ({
  data,
  defaultHistoryToggleValue = false,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dataCurrent = (data && data.currentDetail) ?? [];
  const dataAll = (data && data.historicDetail) ?? [];
  const [showHistory, toggleHistory] = useState<boolean>(defaultHistoryToggleValue);
  const [visibleData, setVisibleData] = useState(dataCurrent);

  useEffect(() => {
    setVisibleData(showHistory ? dataAll : dataCurrent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showHistory]);

  return (
    <DetailsDataTable
      data={visibleData}
      actions={
        <Button
          onClick={() => toggleHistory(!showHistory)}
          className={classes.btn}
          startIcon={<HistoryIcon />}
          size="small"
          color="primary"
        >
          {t(`companies:${showHistory ? 'hideHistory' : 'showHistory'}`)}
        </Button>
      }
      defaultColDef={defaultColDef}
      {...otherProps}
    />
  );
};

const useStyles = makeStyles(() => ({
  btn: {
    textTransform: 'none',
    fontWeight: FontSizes.fontWeight.bold,
  },
}));

export default DetailsDataTableWithHistory;
